import { Store } from "@omni/types/api/store/bff/store.model";
import { CloudStore } from "@omni/types/api/store/cloud/store.model";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const useStoreFullName = (store?: CloudStore | Store | null) => {
    const { t } = useGranite();

    return store?.shopName ? t("general.shopName", store?.shopName) : undefined;
};

export { useStoreFullName };
